<div id="order-table">
  <app-ep-table
    [config]="config"
    [data]="orders$ | async"
    [totalRecords]="totalRecords"
    (pageChange)="pageChangeEvent($event)"
    (globalSearch)="debounceSearch($event)"
    data-cy="order-table"
  ></app-ep-table>
</div>
